import "./blog-slider";
import "./blog-small-posts";
import "./cases-slider";
import "./logo-scroller";
import "./people";
import "./process-flow";
import "./sticky-card-scroll-animation";
import "./tech-stack";
import "./timeline";
import "./values";
import "./what-we-do";
import "./image-slider";
